import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { apiCallChangeMasterEvent, apiCallGetAllMasterEvent } from "../../../../Core/Apicall";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setLoadingFalse, setLoadingTrue } from "../../../../Config/Actions/loadingActions";


export default function MasterEventChange({eventId}) {
    const [fromEventId, SetfromEventId] = useState("");
    const dispatch = useDispatch()

    const submit = async () => {
        if (!fromEventId.trim()) {
            toast.error("Please enter a master event id");
            return;
        }
        try {
            dispatch(setLoadingTrue())
            const payload = {
                "fromMasterEventId": fromEventId,
                "toMasterEventId": eventId
            };
            const res = await apiCallChangeMasterEvent(payload)
            dispatch(setLoadingFalse())
            SetfromEventId("");
            toast.success("Matser event changes successfully!");

        } catch (error) {
            toast.error(error || "Something went wrong");
            dispatch(setLoadingFalse())

        }
    };


    return (
        <div
            style={{
                background: "#071b3a",
                padding: 30,
                color: "#fff",
                fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            }}
        >
            <h2 style={{ marginBottom: 30 }}>Change Master Events Session</h2>

            <div
                style={{
                    display: "flex",
                    gap: 20,
                    alignItems: "center",
                    marginBottom: 30,
                }}
            >

            </div>

            <div
                style={{
                    background: "#0d2b55",
                    borderRadius: 12,
                    padding: 20,
                }}
            >
                <div style={{ display: "flex", gap: "20px" }} >
                    <input
                        value={fromEventId}
                        onChange={(e) => SetfromEventId(e.target.value)}
                        placeholder="Master Events ID"
                        style={{
                            flex: 1,
                            height: 45,
                            borderRadius: 8,
                            border: "1px solid #2f4f80",
                            padding: "0 15px",
                            fontSize: 15,
                            background: "#0d2b55",
                            color: "#fff",
                        }}
                    />
                    <button
                        onClick={submit}
                        style={{
                            height: 45,
                            width: 120,
                            background: "rgb(255, 69, 58)",
                            color: "#fff",
                            border: 0,
                            borderRadius: 8,
                            cursor: "pointer",
                            fontWeight: 600,
                        }}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
}